// collectionItem.js
// Displays a single article card in a vertical editorial list.
// Clicking opens a modal with the full article story.

import React, { useState } from 'react';
import './collectionItem.css';
import Modal from '../../common/Modal/modal';
import CollectionPopup from '../CollectionPopup/collectionPopup';

function CollectionItem({ article, index }) {
    const [open, setOpen] = useState(false);

    const title = article?.name || 'Article';
    const summary = article?.subtitle || '';
    const ThumbnailImages = article?.thumbnails || [];
    const leftImage = ThumbnailImages[0];
    const rightImage = ThumbnailImages[1];
    
    const isEven = index % 2 === 0;

    return (
        <>
            <button
                type="button"
                className={`collection-item-container ${isEven ? 'collection-item-left' : 'collection-item-right'}`}
                onClick={() => setOpen(true)}
                aria-label={`Ouvrir ${title|| 'l’article'}`}
            >
                <div className="collection-item-thumbnail collection-item-thumbnail-left">
                    <img src={leftImage} alt={`${title|| 'Article'} vue 1`} loading="lazy" />
                </div>

                <div className="collection-item-details">
                    <h2>{title}</h2>
                    <p>{summary.length > 140 ? `${summary.slice(0, 140)}…` : summary}</p>
                </div>

                <div className="collection-item-thumbnail collection-item-thumbnail-right">
                    <img src={rightImage} alt={`${title|| 'Article'} vue 2`} loading="lazy" />
                </div>
            </button>

            <Modal isOpen={open} onClose={() => setOpen(false)}>
                <CollectionPopup article={article} />
            </Modal>
        </>
    );
}

export default CollectionItem;